import script from "./TaskCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./TaskCard.vue?vue&type=script&lang=ts&setup=true"

import "./TaskCard.vue?vue&type=style&index=0&id=22d38a82&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22d38a82"]])

export default __exports__